import React from 'react';
import {Row, Col} from 'react-bootstrap';
import { LoadingStyledArticleListItem, LoadingStyledArticleListItemThumb, LoadingStyledArticleListItemTitle } from "../../../utils/loading-styles";

export const LoadingArticleListItem = () => {

    return (
        <LoadingStyledArticleListItem>
            <Row>
                <Col xs={12} md={6}>
                    <LoadingStyledArticleListItemThumb>
                        &nbsp;
                    </LoadingStyledArticleListItemThumb>
                </Col>
                <Col xs={12} md={6}>
                    <LoadingStyledArticleListItemTitle>
                        <h5>&nbsp;</h5>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p> 
                    </LoadingStyledArticleListItemTitle>
                </Col>
            </Row>
        </LoadingStyledArticleListItem>   
    )
}